import { render } from "./product-settings.vue?vue&type=template&id=9b11c682"
import script from "./product-settings.vue?vue&type=script&lang=js"
export * from "./product-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__